import { RouteConfig } from 'vue-router';
import _ from 'lodash';

import { NAME } from '../constants';
import NDSkladZakPolozky from './NDSkladZakPolozky.vue';
import PrijemNDDodList from './PrijemNDDodList.vue';
import PrehledProvedenychKorekciPCND from './PrehledProvedenychKorekciPCND.vue';
import PrehledProvedenychKorekciStavuND from './PrehledProvedenychKorekciStavuND.vue';
import VydejZboziZeSkladuZaObdobi from './VydejZboziZeSkladuZaObdobi.vue';
import OductovaneKorekcePncZaObdobi from './OductovaneKorekcePncZaObdobi.vue';
import KontrolniOpisSkladoveVydejky from './KontrolniOpisSkladoveVydejky.vue';
import Inventory from './Inventory.vue';

export const children: RouteConfig[] = _.map([
	{
		name: 'NDSkladZakPolozky',
		path: 'NDSkladZakPolozky',
		component: NDSkladZakPolozky,
	},
	{
		name: 'Inventory',
		path: 'Inventory',
		component: Inventory,
	},
	{
		name: 'PrijemNDDodList',
		path: 'PrijemNDDodList',
		component: PrijemNDDodList,
	},
	{
		name: 'PrehledProvedenychKorekciPCND',
		path: 'PrehledProvedenychKorekciPCND',
		component: PrehledProvedenychKorekciPCND,
	},
	{
		name: 'PrehledProvedenychKorekciStavuND',
		path: 'PrehledProvedenychKorekciStavuND',
		component: PrehledProvedenychKorekciStavuND,
	},
	{
		name: 'VydejZboziZeSkladuZaObdobi',
		path: 'VydejZboziZeSkladuZaObdobi',
		component: VydejZboziZeSkladuZaObdobi,
	},
	{
		name: 'OductovaneKorekcePncZaObdobi',
		path: 'OductovaneKorekcePncZaObdobi',
		component: OductovaneKorekcePncZaObdobi,
	},
	{
		name: 'KontrolniOpisSkladoveVydejky',
		path: 'KontrolniOpisSkladoveVydejky',
		component: KontrolniOpisSkladoveVydejky,
	},
], (route) => ({ ...route, meta: { objectName: NAME } }));
